import { useMemo } from 'react';
import { startOfWeek, endOfWeek } from 'date-fns';
import dayjs from 'dayjs';
import { WeekPicker } from '../../../summary/components/datePickers/weekPicker/WeekPicker';
import { getGridDateTimeMode, toGridFilterStartOfDay, toGridFilterEndOfDay } from '../../utils';
import type { DateFilterRendererProps } from './DateRangeFilter';

export const WeekFilterRenderer = ({
  onDateRangeChange,
  initialDateRange,
  command,
}: DateFilterRendererProps) => {
  const dateTimeMode = getGridDateTimeMode(command.settings);
  const startDate = initialDateRange?.startDate;

  const initialWeek = useMemo(() => {
    if (!startDate) return undefined;
    const date = new Date(startDate);
    if (isNaN(date.getTime())) return undefined;
    return {
      firstDay: startOfWeek(date, { weekStartsOn: 1 }),
      lastDay: endOfWeek(date, { weekStartsOn: 1 }),
    };
  }, [startDate]);

  const pickerKey = initialWeek ? initialWeek.firstDay.toISOString() : 'session';

  return (
    <WeekPicker
      key={pickerKey}
      useLocalTime={false}
      initialWeek={initialWeek}
      onChange={(week) => {
        const monday = startOfWeek(week.firstDay, { weekStartsOn: 1 });
        const sunday = endOfWeek(week.firstDay, { weekStartsOn: 1 });
        onDateRangeChange(
          toGridFilterStartOfDay(dayjs(monday), dateTimeMode),
          toGridFilterEndOfDay(dayjs(sunday), dateTimeMode)
        );
      }}
    />
  );
};
